import React, { useEffect, useState } from "react";
import { fetchEmergencyContacts } from "../lib/api";
import { Phone, ShieldAlert, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export default function Emergency() {
    const [data, setData] = useState(null);
    useEffect(() => { fetchEmergencyContacts().then(setData).catch(() => {}); }, []);

    return (
        <div className="max-w-3xl mx-auto px-6 lg:px-12 py-10 lg:py-14 fade-up" data-testid="emergency-page">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#B91C1C] font-semibold mb-3">Emergency</div>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: "Outfit" }}>Emergency Contacts</h1>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                In a life-threatening situation, always call <strong>999</strong> first. For BSCC-specific issues, use the contacts below.
            </p>

            <div className="bg-[#FFF4F2] border-l-4 border-[#B91C1C] p-5 rounded-r-md mb-8 flex gap-3" data-testid="emergency-999">
                <AlertTriangle className="h-5 w-5 text-[#B91C1C] flex-shrink-0 mt-0.5" />
                <div className="text-[15px] text-gray-700 leading-relaxed">
                    <strong>999</strong> — Police, Fire, Ambulance, Coastguard. Use for any life-threatening situation.
                </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 sm:p-8 mb-6">
                <div className="flex items-center gap-3 mb-4">
                    <div className="h-10 w-10 rounded-full bg-[#2C7A85] grid place-items-center text-white">
                        <ShieldAlert className="h-5 w-5" />
                    </div>
                    <div>
                        <div className="font-semibold text-gray-900" style={{ fontFamily: "Outfit" }}>BSCC Office</div>
                        <div className="text-sm text-gray-500">Open during office hours</div>
                    </div>
                </div>
                <a href={`tel:${(data?.office || "").replace(/\s/g, "")}`} className="inline-flex items-center gap-2 text-2xl font-semibold text-[#2C7A85] hover:underline" data-testid="office-phone-link">
                    <Phone className="h-5 w-5" /> {data?.office || "01479 810004"}
                </a>
            </div>

            <div className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3" style={{ fontFamily: "Outfit" }}>Out of Hours</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                {(data?.out_of_hours || []).map(c => (
                    <a
                        key={c.name}
                        href={`tel:${c.phone.replace(/\s/g, "")}`}
                        className="bg-white border border-gray-200 rounded-lg p-5 hover:border-[#2C7A85] hover:shadow-sm transition-all"
                        data-testid={`out-of-hours-${c.name}`}
                    >
                        <div className="text-[11px] uppercase tracking-widest text-gray-500 mb-1">Contact</div>
                        <div className="font-semibold text-gray-900 mb-2" style={{ fontFamily: "Outfit" }}>{c.name}</div>
                        <div className="inline-flex items-center gap-2 text-[#2C7A85] font-medium">
                            <Phone className="h-4 w-4" /> {c.phone}
                        </div>
                    </a>
                ))}
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
                <div className="text-sm font-semibold text-gray-900 mb-2" style={{ fontFamily: "Outfit" }}>Need to know what to do?</div>
                <div className="text-[15px] text-gray-700 mb-3 leading-relaxed">
                    Read the full Emergency Procedures section — accident, breakdown, unwell or aggressive passenger.
                </div>
                <Link to="/section/emergency-procedures" className="inline-flex items-center gap-1 text-[#2C7A85] font-medium hover:underline" data-testid="link-emergency-procedures">
                    Open Emergency Procedures →
                </Link>
            </div>
        </div>
    );
}
